import { getPriceOffPercentage } from '../templates/product-listing-page/PlpUtils/ProcessBadgeDiscount';
import { exclusiveSaleState } from '../templates/product/components/ExclusiveSaleProductPrice/state';
import { ExclusiveSaleConfigurations } from '../templates/product/components/ExclusiveSaleProductPrice/types';
import { fetchDataFromBuilder, getBuilderCacheBusterKey } from './builder';

export const fetchExclusiveSaleConfigFromBuilder = async function () {
  if (exclusiveSaleState.isConfigFetched) return; // Prevent duplicate fetches

  const maxRetries = 5;
  let attempt = 0;

  while (attempt < maxRetries) {
    try {
      const data = await fetchDataFromBuilder<ExclusiveSaleConfigurations>('sale-configurations', {
        options: { cb: getBuilderCacheBusterKey() },
      }).then((resp) => resp?.data || null);

      exclusiveSaleState.setExclusiveSaleState(data);

      return; // Success, exit the function
    } catch (error) {
      attempt++;
      console.warn(`Error fetching exclusive sale config from Builder (attempt ${attempt}/${maxRetries}):`, error);

      if (attempt >= maxRetries) {
        return; // Give up after max retries
      }

      // Wait for 1s before retrying
      const delay = 1000;
      await new Promise((resolve) => setTimeout(resolve, delay));
    }
  }
};

export const updatePercentageInMembersExclusiveBadge = (props: {
  badge: string;
  price: number;
  compareAtPrice: number;
}) => {
  const { badge, price, compareAtPrice } = props;
  const percentageMatch = badge.match(/(\S+)%/);
  if (percentageMatch) {
    const percentage = getPriceOffPercentage(price, compareAtPrice);
    return badge.replace(/(\S+)%/, `${percentage}%`);
  }
  return badge;
};

export const getExclusiveSaleOfferCopy = (formattedPrice: string) => {
  const { membersExclusiveState, appOnlySaleState } = exclusiveSaleState;

  const { isEnabled: isMembersExclusiveEnabled, guestUserDiscountCopy } = membersExclusiveState;

  const { isEnabled: isAppOnlySaleEnabled, appOnlySaleDiscountCopy } = appOnlySaleState;

  // get copty based on the gflag
  const discountCopy = isAppOnlySaleEnabled
    ? appOnlySaleDiscountCopy
    : isMembersExclusiveEnabled
    ? guestUserDiscountCopy
    : null;

  return discountCopy ? discountCopy.replace(/%S/i, formattedPrice) : null;
};

export const getExclusiveSaleOfferCopyColor = () => {
  const { membersExclusiveState, appOnlySaleState } = exclusiveSaleState;

  const { isEnabled: isMembersExclusiveEnabled, guestUserDiscountCopyColor } = membersExclusiveState;

  const { isEnabled: isAppOnlySaleEnabled, appOnlySaleDiscountCopyColor } = appOnlySaleState;

  return isAppOnlySaleEnabled
    ? appOnlySaleDiscountCopyColor
    : isMembersExclusiveEnabled
    ? guestUserDiscountCopyColor
    : '#53B19C';
};
